import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { Operators } from './types'

export const fetchOperatorList = async (params?: { abortCtrl?: AbortController | AbortSignal, divisionIds?: string }) => {
  return wretchClient
    .url('/admin/1.0/operators')
    .signal(params?.abortCtrl)
    .query(params?.divisionIds ? { divisionIds: params.divisionIds } : {})
    .get()
    .json<ListingResponse<Operators>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
